import { render, staticRenderFns } from "./ServiceFour.vue?vue&type=template&id=231667f9"
import script from "./ServiceFour.vue?vue&type=script&lang=js"
export * from "./ServiceFour.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports